import api from "./api";

const advancedReportService = {
  getDepartmentReport: (params) =>
    api.get("/analytics/reports/department", { params }),
  getClassReport: (params) =>
    api.get("/analytics/reports/class", { params }),
  getStudentDetailReport: (studentId, params) =>
    api.get(`/analytics/reports/student/${studentId}`, { params }),
  getSubjectReport: (params) =>
    api.get("/analytics/reports/subject", { params }),
  downloadDepartmentReportXlsx: (params) =>
    api.get("/analytics/reports/department/export", { params, responseType: "blob" }),
  downloadClassReportXlsx: (params) =>
    api.get("/analytics/reports/class/export", { params, responseType: "blob" }),
  downloadSubjectReportXlsx: (params) =>
    api.get("/analytics/reports/subject/export", { params, responseType: "blob" }),
  downloadStudentDetailReportXlsx: (studentId, params) =>
    api.get(`/analytics/reports/student/${studentId}/export`, { params, responseType: "blob" }),
  /** Returns PDF blob (POST) */
  requestStudentReportDownload: (payload) =>
    api.post(
      "/reports/student/download",
      { ...payload, responseType: "pdf" },
      {
        headers: { Accept: "application/pdf" },
        responseType: "blob",
      }
    ),
  /** Returns unified JSON for in-app preview (POST) */
  requestStudentReportPreview: (payload) =>
    api.post(
      "/reports/student/download",
      { ...payload, responseType: "data" },
      {
        headers: { Accept: "application/json" },
      }
    ),
  /** XLSX — HOD, institute admin, and above */
  downloadAttendanceDefaulterMatrix: (params) =>
    api.get("/analytics/reports/attendance-defaulter-matrix", {
      params,
      responseType: "blob",
    }),
};

export default advancedReportService;
